import React from 'react';

interface CalculatorWarningProps {
  message: string | React.ReactNode;
  type?: 'warning' | 'urgent' | 'info';
}

/**
 * Standardized warning component for calculator pages
 */
const CalculatorWarning: React.FC<CalculatorWarningProps> = ({ message, type = 'warning' }) => {
  // Icons for different warning types
  const icons = {
    warning: '⚠️ ',
    urgent: '🚨 ',
    info: 'ℹ️ ',
  };

  const styles = {
    warning: {
      color: '#ff4444',
      padding: '8px',
      margin: '10px 0',
      fontWeight: 'bold' as const,
      borderRadius: '4px',
    },
    urgent: {
      backgroundColor: '#ff0000',
      color: 'white',
      padding: '8px',
      margin: '10px 0',
      fontWeight: 'bold' as const,
      borderRadius: '4px',
    },
    info: {
      backgroundColor: '#2196F3',
      color: 'white',
      padding: '8px',
      margin: '10px 0',
      fontWeight: 'bold' as const,
      borderRadius: '4px',
    },
  };

  // If message is a string, prepend the icon
  // If it's a ReactNode, we need to handle it differently
  const messageWithIcon =
    typeof message === 'string' ? (
      icons[type] + message
    ) : (
      <>
        {icons[type]}
        {message}
      </>
    );

  return (
    <div className={`warning-text ${type}`} style={styles[type]}>
      {messageWithIcon}
    </div>
  );
};

export default CalculatorWarning;
